// src/components/store/sections/gallery/GalleryV10CinemareelIndigoPulse.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV10CinemareelIndigoPulse(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={10}
      archKey="cinema_reel"
      archLabel="Cinema Filmstrip Reel"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
